import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExplosionArticulo from "../../Ventas/Pedidos/ExplosionArticulo";
import FotosArticulo from "../../Articulos/Articulos/FotosArticulo";
import DatosOrdenProduccion, { datosOrdenDeArticulo, datosOrdenVacios } from "./DatosOrdenProduccion";

/**
 * Nueva orden de maquila, directo sobre el pedido.
 *
 * Ya no hay orden de produccion en medio: aqui se escoge el pedido, el
 * maquilero y cuantas piezas de cada talla y color se le mandan. La merma y el
 * redondeo por renglon los resuelve el back, que es donde vive la regla; la
 * pantalla solo muestra el resultado.
 */
/** Pedido con todos sus articulos: un pedido puede traer varios modelos. */
const etiquetaPedido = (p) =>
  [
    p.idPedido,
    p.clientes?.[0]?.nombre_comercial ?? "",
    (p.articulos || []).map((a) => a?.codigo).filter(Boolean).join(", "),
  ]
    .filter(Boolean)
    .join(" ");

function CortesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_CORTES_DESDE_PEDIDO = process.env.REACT_APP_URL_CORTES_DESDE_PEDIDO;

  const hoy = moment(new Date()).format("YYYY-MM-DD");

  const [pedidos, setPedidos] = useState([]);
  const [maquileros, setMaquileros] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedMaquilero, setSelectedMaquilero] = useState("");
  const [value, setValue] = useState("");
  const [cliente, setCliente] = useState("");
  const [fecha] = useState(hoy);
  const [fechaCompromiso, setFechaCompromiso] = useState("");
  const [precioMaquila, setPrecioMaquila] = useState(0);
  const [consumoRealPrenda, setConsumoRealPrenda] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  // Lo que sale en la Orden de Produccion (PDF): se prellena con el articulo.
  const [datosOrden, setDatosOrden] = useState(datosOrdenVacios());
  const renglonesPedido = useRef([]);
  const nombreUsuario = [user && user.nombre, user && user.apellido].filter(Boolean).join(" ");

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [coloresUnicos, setColoresUnicos] = useState([]);
  // Merma por defecto del articulo elegido; cada renglon la puede cambiar.
  const [mermaDefault, setMermaDefault] = useState(2);
  // Todos los renglones del pedido (tambien los ya mandados): de aqui salen
  // los colores y las piezas para la explosion del articulo.
  const [lineasPedido, setLineasPedido] = useState([]);
  const [modalExplosion, setModalExplosion] = useState(false);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const ordenTallas = ["XCH", "CH", "M", "G", "XG", "7", "9", "11", "13"];

  const cabecera = {
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  };

  useEffect(() => {
    axios
      .get(URL_PEDIDOS, cabecera)
      .then((res) => {
        setPedidos(res.data);
        // Desde Nuevo Pedido se llega con ?pedido=<id> para generar su orden.
        const id = new URLSearchParams(window.location.search).get("pedido");
        const pedido = id && res.data.find((p) => p._id === id);
        if (pedido) {
          setValue({ ...pedido, junta: etiquetaPedido(pedido) });
          jalaPedido(id, res.data);
        }
      })
      .catch((err) => console.log(err));

    axios
      .get(URL_PROVEEDORES, cabecera)
      .then((res) =>
        // El maquilero es un proveedor con tipo "Maquilero".
        setMaquileros(res.data.filter((prov) => prov.tipo === "Maquilero"))
      )
      .catch((err) => console.log(err));
  }, []);

  // Renglones del articulo elegido: la orden de maquila es de un solo articulo.
  const renglonesDelArticulo = articulosPedido.filter(
    (a) => a.idArticulo === selectedArticulo
  );

  const totalPiezas = renglonesDelArticulo.reduce(
    (t, a) => t + (parseFloat(a.cantidad) || 0),
    0
  );

  // Mismo calculo que el back: hacia arriba y por renglon. Es solo para
  // mostrar; lo que cuenta es lo que el back guarda.
  const aProducir = (a) =>
    Math.ceil(Number(((parseFloat(a.cantidad) || 0) * (1 + (parseFloat(a.porcentajeMerma) || 0) / 100)).toFixed(6)));
  const totalProducir = renglonesDelArticulo.reduce((t, a) => t + aProducir(a), 0);

  function eligeArticulo(id) {
    setSelectedArticulo(id);
    if (!id) return;
    // El modelo del cliente viene en los renglones del pedido.
    const modelo = (renglonesPedido.current.find((r) => r.idArticulo === id && r.codigoCliente) || {}).codigoCliente;
    datosOrdenDeArticulo(id, nombreUsuario, modelo).then(setDatosOrden);
    axios
      .get(`${URL_CORTES}MermaArticulo/${id}`, cabecera)
      .then((res) => {
        const m = res.data.porcentajeMerma;
        setMermaDefault(m);
        // Prellena la merma de los renglones de ese articulo con su default.
        setArticulosPedido((previos) =>
          previos.map((r) => (r.idArticulo === id ? { ...r, porcentajeMerma: m } : r))
        );
      })
      .catch((err) => console.log(err));
  }

  function jalaPedido(id, listaPedidos = pedidos) {
    setSelectedPedido(id);
    setSelectedArticulo("");

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${id}`, cabecera)
      .then((res) => {
        setLineasPedido(
          res.data.map((a) => ({
            idArticulo: a.articulos?.[0]?._id,
            codigo: a.articulos?.[0]?.codigo,
            descripcion: a.articulos?.[0]?.descripcion,
            idColor: a.colores?.[0]?._id,
            color: a.colores?.[0]?.name,
            cantidad: a.cantidad || 0,
          }))
        );
        // Solo se puede mandar a maquila lo que sigue pendiente.
        const renglones = res.data
          .map((a) => ({
            _id: a._id,
            idArticulo: a.articulos?.[0]?._id,
            articuloNombre:
              (a.articulos?.[0]?.codigoCliente ?? "") +
              " " +
              (a.articulos?.[0]?.codigo ?? "") +
              " " +
              (a.articulos?.[0]?.descripcion ?? ""),
            talla: a.tallas?.[0]?.name,
            color: a.colores?.[0]?.name,
            pendiente: a.pendienteCortar ?? 0,
            sku: a.codigoBarras && String(a.codigoBarras) !== "0" ? String(a.codigoBarras) : "",
            codigoCliente: a.codigoCliente && a.codigoCliente !== "NA" ? a.codigoCliente : "",
            cantidad: a.pendienteCortar ?? 0,
            porcentajeMerma: mermaDefault,
          }))
          .filter((a) => a.pendiente > 0);

        renglonesPedido.current = renglones;
        setArticulosPedido(renglones);

        const porArticulo = new Map();
        const porColor = new Map();
        for (const r of renglones) {
          porArticulo.set(r.idArticulo, {
            idArticulo: r.idArticulo,
            articuloNombre: r.articuloNombre,
          });
          porColor.set(`${r.idArticulo}|${r.color}`, {
            idArticulo: r.idArticulo,
            color: r.color,
          });
        }
        setArticulosUnicos([...porArticulo.values()]);
        setColoresUnicos([...porColor.values()]);
        // Con un solo articulo pendiente no hay nada que elegir.
        if (porArticulo.size === 1) eligeArticulo([...porArticulo.keys()][0]);
      })
      .catch((err) => console.log(err));

    const pedido = listaPedidos.find((a) => a._id === id);
    if (pedido) {
      setCliente(pedido.clientes?.[0]?.nombre_comercial ?? "");
    }
  }

  const handleChangeInputCantidad = (id, event) => {
    const valor = parseFloat(event.target.value);
    setArticulosPedido((previos) =>
      previos.map((i) => (i._id === id ? { ...i, cantidad: isNaN(valor) ? 0 : valor } : i))
    );
  };

  const handleChangeSku = (id, event) => {
    const valor = event.target.value.replace(/\D/g, "");
    setArticulosPedido((previos) => previos.map((i) => (i._id === id ? { ...i, sku: valor } : i)));
  };

  const handleChangeMerma = (id, event) => {
    const valor = event.target.value;
    setArticulosPedido((previos) =>
      previos.map((i) => (i._id === id ? { ...i, porcentajeMerma: valor } : i))
    );
  };

  const saveCorte = async (event) => {
    event.preventDefault();

    if (!selectedPedido) {
      return Swal.fire({ icon: "error", title: "Falta el pedido" });
    }
    if (!selectedArticulo) {
      return Swal.fire({ icon: "error", title: "Falta el articulo" });
    }
    if (!selectedMaquilero) {
      return Swal.fire({ icon: "error", title: "Falta el maquilero" });
    }

    const renglones = renglonesDelArticulo
      .filter((a) => parseFloat(a.cantidad) > 0)
      .map((a) => ({
        articulosPedido: a._id,
        cantidadPedido: parseFloat(a.cantidad),
        porcentajeMerma: parseFloat(a.porcentajeMerma) || 0,
        sku: a.sku || "",
      }));

    if (renglones.length === 0) {
      return Swal.fire({
        icon: "warning",
        title: "Sin renglones",
        text: "No hay piezas por mandar a maquila",
      });
    }

    const mermaMala = renglonesDelArticulo.find((a) => {
      const m = parseFloat(a.porcentajeMerma);
      return parseFloat(a.cantidad) > 0 && (isNaN(m) || m < 0 || m > 100);
    });
    if (mermaMala) {
      return Swal.fire({
        icon: "error",
        title: "Merma invalida",
        text: `Talla ${mermaMala.talla} ${mermaMala.color}: la merma va de 0 a 100%`,
      });
    }

    const excedido = renglonesDelArticulo.find(
      (a) => parseFloat(a.cantidad) > a.pendiente
    );
    if (excedido) {
      return Swal.fire({
        icon: "error",
        title: "Te pasaste del pedido",
        text: `Talla ${excedido.talla} ${excedido.color}: quedan ${excedido.pendiente} pzas por mandar`,
      });
    }

    if (!URL_CORTES_DESDE_PEDIDO) {
      // CRA solo lee el .env al arrancar: si la variable se agrego con el
      // front corriendo, aqui llega undefined y la peticion nunca sale.
      return Swal.fire({
        icon: "error",
        title: "Falta configuracion",
        text: "No esta definida REACT_APP_URL_CORTES_DESDE_PEDIDO. Reinicia el front para que lea el .env.",
      });
    }

    setValidaBoton(false);
    // Explicito y no toggle: el toggle lee el estado de cuando se creo la
    // funcion y en el catch volvia a abrir el modal en lugar de cerrarlo.
    setModalProgreso(true);
    try {
      // Una sola llamada: la orden, sus renglones y el descuento al pedido se
      // aplican dentro de una transaccion, no en una cadena de POST desde aqui.
      const { data } = await axios.post(
        URL_CORTES_DESDE_PEDIDO,
        {
          fecha,
          pedidos: selectedPedido,
          articulos: selectedArticulo,
          proveedores: selectedMaquilero,
          fechaCompromiso,
          precioMaquila: parseFloat(precioMaquila) || 0,
          consumoRealPrenda: parseFloat(consumoRealPrenda) || 0,
          observaciones,
          ...datosOrden,
          renglones,
        },
        cabecera
      );

      // Se crea una orden por color (tono) del pedido.
      const ordenes = data.ordenes || [{ cortes: data.cortes, totalPedido: data.totalPedido, totalProducir: data.totalProducir }];
      await Promise.all(
        ordenes.map((o) =>
          axios.post(URL_LOGS, { tipo: "Crear Orden de Maquila", detalle: `${o.cortes._id}`, user: user.id }, cabecera)
        )
      );

      await Swal.fire({
        icon: "success",
        title:
          ordenes.length === 1
            ? `Orden de maquila ${ordenes[0].cortes.numero} creada`
            : `${ordenes.length} órdenes de maquila creadas (una por color)`,
        html:
          (ordenes.length > 1
            ? ordenes
                .map((o) => `Orden <b>${o.cortes.numero}</b> ${o.colorNombre || ""}: ${o.totalProducir} pzas a producir`)
                .join("<br/>") + "<br/><br/>"
            : "") +
          `Pedido: <b>${data.totalPedido}</b> pzas<br/>` +
          `Merma aplicada: <b>${data.porcentajeMerma}%</b><br/>` +
          `A producir: <b>${data.totalProducir}</b> pzas`,
      });
      window.location.reload();
    } catch (error) {
      setModalProgreso(false);
      const respuesta = error.response;
      const info = (respuesta && respuesta.data) || {};
      // celebrate manda el detalle del campo en validation.body.message.
      const detalleValidacion = info.validation?.body?.message;
      const texto =
        info.message && detalleValidacion
          ? `${info.message}: ${detalleValidacion}`
          : info.message ||
            (respuesta
              ? `El servidor respondio ${respuesta.status}`
              : "No hubo respuesta del servidor. Revisa que el back este corriendo.");
      Swal.fire({ icon: "error", title: "No se pudo crear la orden", text: texto });
      console.log(error);
      setValidaBoton(true);
    }
  };

  // Articulo elegido con sus colores y piezas en el pedido, para la explosion.
  const lineasArticulo = lineasPedido.filter((l) => l.idArticulo === selectedArticulo);
  const articuloExplosion = lineasArticulo.length
    ? {
        _id: selectedArticulo,
        codigo: lineasArticulo[0].codigo,
        descripcion: lineasArticulo[0].descripcion,
        colores: [...new Map(lineasArticulo.map((l) => [l.idColor, { _id: l.idColor, name: l.color }])).values()],
      }
    : null;
  const piezasPorColor = {};
  lineasArticulo.forEach((l) => {
    piezasPorColor[l.idColor] = (piezasPorColor[l.idColor] || 0) + l.cantidad;
  });

  const options = pedidos.map((option) => {
    const junta = etiquetaPedido(option);
    const firstLetter = String(option.idPedido ?? "");
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter || "#",
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Nueva Orden de Maquila
              </h3>
              <p className="page-subtitle">
                Manda a producir un pedido con un maquilero
              </p>
            </div>
          </div>

          <ExplosionArticulo
            isOpen={modalExplosion && !!articuloExplosion}
            toggle={() => setModalExplosion(false)}
            pedido={selectedPedido}
            articulo={articuloExplosion}
            piezasPorColor={piezasPorColor}
          />
          <Form>
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-info-circle" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={4}>
                    <Label className="mr-sm-2">Pedido</Label>
                    <Autocomplete
                      size="small"
                      value={value}
                      onChange={(event, seleccionado) => {
                        if (seleccionado) {
                          setValue(seleccionado);
                          jalaPedido(seleccionado._id);
                        }
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona" variant="outlined" />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>{etiquetaPedido(option)}</React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={4}>
                    <Label>Cliente</Label>
                    <Input type="text" value={cliente} disabled />
                  </Col>
                  <Col md={4}>
                    <Label>Fecha</Label>
                    <Input type="date" value={fecha} disabled />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label className="mr-sm-2">Maquilero</Label>
                    <Input
                      type="select"
                      value={selectedMaquilero}
                      required
                      onChange={(e) => setSelectedMaquilero(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {maquileros
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => (
                          <option value={a._id} key={a._id}>
                            {a.nombre_comercial}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Fecha Compromiso</Label>
                    <Input
                      type="date"
                      value={fechaCompromiso}
                      onChange={(e) => setFechaCompromiso(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Precio Maquila x Prenda</Label>
                    <Input
                      type="number"
                      value={precioMaquila}
                      onChange={(e) => setPrecioMaquila(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Consumo Tela x Prenda</Label>
                    <Input
                      type="number"
                      value={consumoRealPrenda}
                      onChange={(e) => setConsumoRealPrenda(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-tshirt" />
                <span className="form-section-title">Articulos</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={7}>
                    <Label className="mr-sm-2">Articulo</Label>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedArticulo}
                      onChange={(e) => eligeArticulo(e.target.value)}
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => (
                          <option value={a.idArticulo} key={a.idArticulo}>
                            {a.articuloNombre}
                          </option>
                        ))}
                    </Input>
                    <Button
                      size="sm"
                      color="info"
                      title="Explosión del artículo en este pedido"
                      disabled={!selectedArticulo}
                      onClick={() => setModalExplosion(true)}
                    >
                      <span style={{ whiteSpace: "nowrap" }}>
                        <i className="fas fa-tape" /> Explosión
                      </span>
                    </Button>
                    </div>
                  </Col>
                  {selectedArticulo ? (
                    <Col md={5}>
                      <Label>Fotos del artículo (todas salen en la Orden de Producción)</Label>
                      <FotosArticulo id={selectedArticulo} tamano={70} />
                    </Col>
                  ) : null}
                </Row>
                {selectedArticulo ? (
                  <>
                    <h6 className="mt-3">Datos de la Orden de Producción</h6>
                    <DatosOrdenProduccion valor={datosOrden} onChange={setDatosOrden} />
                  </>
                ) : null}
                <br />

                {selectedPedido && articulosUnicos.length === 0 ? (
                  <Row>
                    <Col md={12}>
                      <Label>
                        Este pedido ya se mando completo a maquila: no le queda
                        nada pendiente.
                      </Label>
                    </Col>
                  </Row>
                ) : undefined}

                {coloresUnicos
                  .filter((col) => col.idArticulo === selectedArticulo)
                  .map((col) => (
                    <Row className="align-items-center" key={col.color}>
                      <Col xs={12} md={2}>
                        <Label>{col.color}</Label>
                      </Col>
                      <Col xs={12} md={10}>
                        <div className="table-responsive">
                          <table className="table table-sm w-100">
                            <thead>
                              <tr>
                                <th>Talla</th>
                                <th>Pendiente</th>
                                <th>Cantidad</th>
                                <th>% Merma</th>
                                <th>A producir</th>
                                <th>SKU</th>
                              </tr>
                            </thead>
                            <tbody>
                              {renglonesDelArticulo
                                .filter((a) => a.color === col.color)
                                .sort((a, b) => {
                                  const ia = ordenTallas.indexOf(a.talla);
                                  const ib = ordenTallas.indexOf(b.talla);
                                  return (
                                    (ia === -1 ? Infinity : ia) -
                                    (ib === -1 ? Infinity : ib)
                                  );
                                })
                                .map((a) => (
                                  <tr key={a._id}>
                                    <td>
                                      <Label>{a.talla}</Label>
                                    </td>
                                    <td>{a.pendiente}</td>
                                    <td>
                                      <Input
                                        bsSize="sm"
                                        name="cantidad"
                                        type="number"
                                        value={a.cantidad}
                                        max={a.pendiente}
                                        onChange={(event) =>
                                          handleChangeInputCantidad(a._id, event)
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Input
                                        bsSize="sm"
                                        name="porcentajeMerma"
                                        type="number"
                                        min={0}
                                        max={100}
                                        step="0.5"
                                        value={a.porcentajeMerma}
                                        onChange={(event) => handleChangeMerma(a._id, event)}
                                      />
                                    </td>
                                    <td>
                                      <b>{aProducir(a)}</b>
                                    </td>
                                    <td>
                                      <Input
                                        bsSize="sm"
                                        value={a.sku}
                                        placeholder="Código de barras"
                                        onChange={(event) => handleChangeSku(a._id, event)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  ))}

                <Row>
                  <Col md={12}>
                    <h4 id="logoutBoton">
                      TOTALES {new Intl.NumberFormat("en-US").format(totalPiezas)}{" "}
                      pzas. del pedido · A producir{" "}
                      {new Intl.NumberFormat("en-US").format(totalProducir)} pzas.
                    </h4>
                    <p className="text-muted">
                      La merma sugerida es {mermaDefault}%; se puede cambiar por
                      talla y color, y se guarda lo que quede capturado.
                    </p>
                  </Col>
                </Row>
              </div>
            </div>
          </Form>

          <br />
          <div className="submit-bar">
            <Button href="/ListadoCortes" className="btn btn-danger" id="botonListado" tabindex="-1">
              Regresar
            </Button>
            {validaBoton ? (
              <Button type="submit" className="btn btn-success" tabindex="-1" onClick={saveCorte}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled tabindex="-1">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </div>
          <br />

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default CortesCreate;
